module.exports = "/layout/app/images/bg-newsletter.fca58898.svg";